/**
 * Popnetic Predictive Prefetching
 * Prefetches likely next pages based on:
 * 1. Hover intent (desktop) - prefetch on hover after 100ms
 * 2. Viewport proximity (mobile) - prefetch links entering viewport
 * 3. Navigation patterns - predict based on common paths
 * 
 * Uses requestIdleCallback to avoid blocking main thread.
 * Respects data-saver mode and slow connections.
 */

(function() {
  'use strict';

  // Abort if user prefers reduced data
  if (navigator.connection) {
    if (navigator.connection.saveData) return;
    if (['slow-2g', '2g'].includes(navigator.connection.effectiveType)) return;
  }

  var prefetched = new Set();
  var MAX_PREFETCH = 6;
  var hoverTimer = null;

  function shouldPrefetch(url) {
    if (prefetched.size >= MAX_PREFETCH) return false;
    if (prefetched.has(url)) return false;
    if (!url || url.startsWith('#') || url.startsWith('javascript:')) return false;
    if (url.includes('/cart') || url.includes('/checkout') || url.includes('/account')) return false;

    try {
      var parsed = new URL(url, window.location.origin);
      if (parsed.origin !== window.location.origin) return false;
      if (parsed.pathname === window.location.pathname) return false;
    } catch(e) { return false; }

    return true;
  }

  function prefetch(url) {
    if (!shouldPrefetch(url)) return;
    prefetched.add(url);

    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url;
    link.as = 'document';
    document.head.appendChild(link);
  }

  // Desktop: prefetch on hover after 100ms intent
  document.addEventListener('mouseover', function(e) {
    var link = e.target.closest('a[href]');
    if (!link) return;

    hoverTimer = setTimeout(function() {
      requestIdleCallback(function() {
        prefetch(link.href);
      });
    }, 100);
  });

  document.addEventListener('mouseout', function(e) {
    if (hoverTimer) { clearTimeout(hoverTimer); hoverTimer = null; }
  });

  // Mobile: prefetch links visible in viewport
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          requestIdleCallback(function() {
            prefetch(entry.target.href);
          });
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px' });

    // Observe product card links and nav links
    requestIdleCallback(function() {
      document.querySelectorAll('a.grid-product__link, .site-nav__link[href], .collection-grid-item a').forEach(function(link) {
        if (shouldPrefetch(link.href)) observer.observe(link);
      });
    });
  }

  // Predictive: prefetch likely next pages on product/collection pages
  requestIdleCallback(function() {
    var path = window.location.pathname;

    // On collection page, prefetch first 2 products
    if (path.includes('/collections/') && !path.includes('/products/')) {
      var productLinks = document.querySelectorAll('.grid-product__link');
      for (var i = 0; i < Math.min(2, productLinks.length); i++) {
        prefetch(productLinks[i].href);
      }
    }

    // On homepage, prefetch featured collections
    if (path === '/') {
      document.querySelectorAll('.collection-grid-item a, .hero__link').forEach(function(link) {
        prefetch(link.href);
      });
    }
  });

  // requestIdleCallback polyfill
  if (!window.requestIdleCallback) {
    window.requestIdleCallback = function(cb) { return setTimeout(cb, 50); };
  }
})();
